export default function BookCover({ variant = "mem", mini = false }) {
  const isMem = variant === "mem";
  return (
    <div
      className={`book ${mini ? "mini" : ""} ${isMem ? "book-mem" : "book-rev"}`}
      data-testid={mini ? `book-cover-mini-${variant}` : `book-cover-${variant}`}
    >
      <div className="book-inner">
        <div className="book-frame">
          <div className="book-kicker">{isMem ? "Guide nº 1" : "Guide nº 2"}</div>
          <div className="book-arabic">{isMem ? "ٱلْحِفْظ" : "ٱلْمُرَاجَعَة"}</div>
          <div className="book-ornament" aria-hidden="true">
            <span />
            <i />
            <span />
          </div>
          <div className="book-title">
            {isMem ? (
              <>
                Mémoriser
                <br />
                le Coran
              </>
            ) : (
              <>
                Réviser
                <br />
                le Coran
              </>
            )}
          </div>
          <div className="book-sub">
            {isMem ? "Le plan de 6 mois" : "Le plan de 30 jours"}
          </div>
          <div className="book-brand">SamNara</div>
        </div>
      </div>
      <div className="book-spine" aria-hidden="true" />
    </div>
  );
}
